import classNames from 'classnames';
import { observer } from 'mobx-react';

import { useMediaQuery } from '../../../hooks/useMediaQuery';
import { useStores } from '../../../stores/useStores';
import { Loader } from '../../Loader/Loader';

import { lobbyBannerHasAnimation } from './bannerAnimation';
import { CasinoHeader } from './CasinoHeader';
import styles from './GenericHeader.module.scss';
import RiveHeader from './rive/RiveHeader';
import TocLobbyHeader from './rive/TocLobbyHeader';
import { useTocLobbyBanner } from './rive/useTocLobbyBanner';

interface GenericHeaderProps {
  bannerClassName?: string;
  fullHeightAnimation?: boolean;
}

export const GenericHeader = observer((props: GenericHeaderProps) => {
  const { bannerClassName, fullHeightAnimation } = props;
  const { uiStore, coinTypeStore } = useStores();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const tocLobbyBanner = useTocLobbyBanner(isMobile);

  if (uiStore.bannersLoading) {
    return (
      <div className={classNames(styles.loaderWrapper, bannerClassName)}>
        <Loader />
      </div>
    );
  }

  const { lobby_cc, lobby_sc, lobby_animation_only } = uiStore.bannerByPage;

  if (tocLobbyBanner.riveUrl) {
    return (
      <TocLobbyHeader
        key={tocLobbyBanner.riveUrl}
        bannerClassName={bannerClassName}
        riveUrl={tocLobbyBanner.riveUrl}
        values={tocLobbyBanner.values}
      />
    );
  }

  if (!lobby_cc || !lobby_sc) {
    return <CasinoHeader />;
  }

  const bgImage = coinTypeStore.coinType === 'GC' ? lobby_cc : lobby_sc;
  const hasAnimation = lobbyBannerHasAnimation(bgImage, lobby_animation_only);

  return (
    <>
      {uiStore.bannerAnimationFlag && hasAnimation ? (
        <RiveHeader
          animationOnly={lobby_animation_only}
          bannerCC={lobby_cc}
          bannerClassName={bannerClassName}
          bannerSC={lobby_sc}
          currentCoinType={coinTypeStore.coinType}
          fullHeightAnimation={fullHeightAnimation}
        />
      ) : (
        <picture>
          {bgImage.mobile && <source media="(max-width: 768px)" srcSet={bgImage.mobile} />}
          <img
            alt="CrownCoinsCasino header"
            className={classNames(styles.banner, bannerClassName)}
            fetchpriority="high"
            src={bgImage.desktop}
          />
        </picture>
      )}
    </>
  );
});
